import { Credential } from '@/model/Authentication';
import HttpEndpoint from '@/model/enums/http/http-endpoint';
import HttpHeader from '@/model/enums/http/http-header';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import { ApiError } from '@/model/ApiError';
import HttpStatus from '@/model/enums/http/http-status';

const ApiClient = axios.create();

ApiClient.defaults.baseURL = process.env.VUE_APP_BASE_URL;

ApiClient.interceptors.request.use(async (config) => {
    const credential: Credential =
        store.getters['authenticationStorage/getCredential'];

    if (config?.headers) {
        if (
            credential?.accessToken &&
            Date.now() >= credential.accessTokenExpiration &&
            HttpEndpoint.REFRESH_URL !== config.url
        ) {
            if (Date.now() >= credential.refreshTokenExpiration) {
                store.commit('authenticationStorage/setCredential', null);
                router.push({ name: 'Login' });
                return config;
            }

            // eslint-disable-next-line no-param-reassign
            config.headers[HttpHeader.AUTHORIZATION] = '';

            await store.dispatch('authenticationStorage/refresh');
        }

        const refreshedCredential: Credential =
            store.getters['authenticationStorage/getCredential'];

        if (
            refreshedCredential?.accessToken &&
            HttpEndpoint.REFRESH_URL !== config.url
        ) {
            // eslint-disable-next-line no-param-reassign
            config.headers[
                HttpHeader.AUTHORIZATION
            ] = `Bearer ${refreshedCredential.accessToken}`;
        }
    }

    return config;
});

ApiClient.interceptors.response.use(
    (response) => {
        return Promise.resolve(response?.data);
    },
    (error) => {
        if (error?.response?.status === HttpStatus.TOKEN_EXPIRED) {
            store.commit('authenticationStorage/setCredential', null);
            router.push({ name: 'Login' });
            return Promise.reject(error);
        }

        const apiError: ApiError = { key: 'general.internal.server.error' };

        if (error?.response?.data?.key) {
            apiError.key = error.response.data.key;
        }

        if (error?.response?.data?.validationMessages) {
            apiError.validationMessages =
                error.response.data.validationMessages;
        }

        return Promise.reject(apiError);
    },
);

export default ApiClient;
